import { render, staticRenderFns } from "./commodity.vue?vue&type=template&id=d9ebaeb2&scoped=true&"
import script from "./commodity.vue?vue&type=script&lang=js&"
export * from "./commodity.vue?vue&type=script&lang=js&"
import style0 from "./commodity.vue?vue&type=style&index=0&id=d9ebaeb2&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9ebaeb2",
  null
  
)

export default component.exports